export class ScriptLoader {
  /**
   * Load script dynamically with script tag
   *
   * @param src href to your external script
   * @param callback optional callback that is executed when script is loaded
   */
  public static loadScript({
    src,
    id = '',
    async = true,
    callback,
    parent = document.head,
  }: {
    src: string;
    id?: string;
    async?: boolean;
    callback?: () => void;
    parent?: Node;
  }) {
    if (ScriptLoader.scriptExists(src)) {
      return;
    }

    const element = document.createElement('script');

    element.src = src;
    element.type = 'text/javascript';
    element.id = id;
    element.async = async;

    if (callback) {
      element.addEventListener('load', callback);
    }

    parent.appendChild(element);
  }

  public static addRs() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src =
      '//cdn1.readspeaker.com/script/5797/webReader/webReader.js?pids=wr&noDefaultSkin=1&mobile=0';
    script.id = 'rs_req_Init';
    document.head.appendChild(script);
  }

  /**
   * Check if there script tag with certain url is present in current DOM
   *
   * @param src href to your external script
   * @param boolean returns true if script already exists
   */
  public static scriptExists(src: string) {
    return !!document.querySelector(`[src="${src}"]`);
  }
}
